import { render, staticRenderFns } from "./WordCardsMatchingExercise.vue?vue&type=template&id=3d901e2f&scoped=true&"
import script from "./WordCardsMatchingExercise.vue?vue&type=script&lang=js&"
export * from "./WordCardsMatchingExercise.vue?vue&type=script&lang=js&"
import style0 from "./WordCardsMatchingExercise.vue?vue&type=style&index=0&id=3d901e2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d901e2f",
  null
  
)

export default component.exports